import ang from './ang.webp';
import aws from './aws.webp';
import java from './java.webp';
import js from './js.webp';
import node from './node.webp';
import py from './py.webp';
import react from './react.webp';

const category = [
  { id: 1, img: ang, name: 'Angular/Vue', c1: 'blue', c2: 'green' },
  { id: 2, img: aws, name: 'React/AWS/Js', c1: 'blue', c2: 'purple' },
  { id: 3, img: java, name: 'Java/C#', c1: 'orange', c2: 'blue' },
  { id: 4, img: js, name: 'JavaScript', c1: 'green', c2: 'yellow' },
  { id: 5, img: node, name: 'Node.js', c1: 'green', c2: 'pink' },
  { id: 6, img: py, name: 'Python', c1: 'yellow', c2: 'orange' },
  { id: 7, img: react, name: 'React/Vue', c1: 'blue', c2: 'green' },
];
export default category;
